import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from "rxjs";
import { AppConfig } from "src/app/core/_config/app.config";
import { BoletoAcertoDto } from "../models/boleto-acerto.model";

@Injectable({
    providedIn: 'root',
})
export class AgreementDetailService {
    private API_URL = this.config.urlApi + 'api/v2/';
    private API_URL_V1 = this.config.urlApi + 'api/v1/';

    constructor(private http: HttpClient, private config: AppConfig) 
    { 

    }

    startAccountingProcess(params: any): Observable<any>  {
        return this.http.post(`${this.API_URL}agreement-external/start-accounting-process`, params);
    }

    receiveSingleSettlement(params: any): Observable<any> {
        return this.http.post(`${this.API_URL_V1}collectionExternal/receiving-externalCollectorAgreement-separate`, params);
    }

    searchBoletos(companyId: string, searchTerm: string): Observable<BoletoAcertoDto[]> {
        return this.http.get<BoletoAcertoDto[]>(`${this.API_URL_V1}CollectionExternal/SearchBillets`, {
            params: { companyId, searchTerm },
        });
    }

    searchBoletosForAdd(filter: string): Observable<BoletoAcertoDto[]> {
        return this.http.get<BoletoAcertoDto[]>(`${this.API_URL}agreement-external/search-billets`, {
            params: { filter },
        });
    }

    addBoletosToAgreement(companyId: string, codigoAcerto: string, codigosCarne: number[]): Observable<any> {
        return this.http.post(`${this.API_URL}agreement-external/adicionar-boletos`, { companyId, codigoAcerto, codigosCarne });
    }

    removeBoletoFromAgreement(companyId: string, codigoAcerto: string, billetId: string): Observable<any> {
        return this.http.delete(`${this.API_URL}agreement-external/remover-boleto/${companyId}/${codigoAcerto}/${billetId}`);
    }
}